import { SITE } from "../lib/site";
import { ArrowDownRight } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden grain"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={SITE.media.hero}
          alt="Glossy black car detail"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 pt-24 pb-24 min-h-[calc(100vh-3rem)] flex flex-col">
        <div className="mt-auto">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-gold" />
            <span
              data-testid="hero-eyebrow"
              className="text-xs uppercase tracking-[0.32em] text-gold/90"
            >
              North Seattle Detailing · Est. 2024
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-display font-light text-white text-[3.2rem] sm:text-7xl lg:text-[7.5rem] leading-[0.95] tracking-tighter max-w-5xl"
          >
            Showroom shine,
            <br />
            <span className="italic gold-shimmer">delivered with care.</span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-8 max-w-xl text-white/70 text-lg leading-relaxed"
          >
            Two local students, professional supplies, and an obsession with
            excellence. Hand-detailing for the Pinehurst, Northgate and greater Northeast
            Seattle area.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-5">
            <a
              href={SITE.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-book-now"
              className="group inline-flex items-center gap-3 px-8 py-4 bg-gold text-black rounded-full text-sm uppercase tracking-[0.22em] font-medium hover:bg-[#F3E5AB] transition-all"
            >
              Book Your Detail
              <ArrowDownRight
                className="transition-transform group-hover:translate-x-1 group-hover:translate-y-1"
                size={18}
              />
            </a>
            <a
              href="#services"
              data-testid="hero-view-services"
              className="inline-flex items-center gap-3 px-8 py-4 border border-white/20 text-white rounded-full text-sm uppercase tracking-[0.22em] hover:border-gold hover:text-gold transition-all"
            >
              View Services
            </a>
          </div>

          {/* Scarcity / urgency banner */}
          <div
            data-testid="hero-scarcity-banner"
            className="mt-8 inline-flex items-center gap-3 text-sm text-white/75"
          >
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75" />
              <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-gold" />
            </span>
            <span className="uppercase tracking-[0.18em] text-xs">
              <span className="text-gold font-medium">Limited weekend slots</span>
              <span className="text-white/55"> — book early to reserve yours</span>
            </span>
          </div>
        </div>

        {/* Bottom metrics row */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-8 border-t border-white/10 pt-10">
          {[
            { k: "Detail packages", v: "3" },
            { k: "Hours of care", v: "Up to 8" },
            { k: "Service area", v: "Northeast Seattle" },
            { k: "Booking", v: "Online · Anytime" },
          ].map((m, i) => (
            <div key={i} data-testid={`hero-metric-${i}`}>
              <div className="text-gold font-display text-3xl lg:text-4xl">
                {m.v}
              </div>
              <div className="mt-1 text-xs uppercase tracking-[0.22em] text-white/50">
                {m.k}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
